import axios from "axios";
import { API_BASE_URL } from "@/constants";
import { getFromStorage } from "@/taskpane/lib";
import { AuthData } from "@/types/auth";
import log from "../utils/logger";

export const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "ngrok-skip-browser-warning": "true",
  },
});

// Add request interceptor to dynamically set auth header
api.interceptors.request.use(async (config) => {
  try {
    const storageUser = await getFromStorage("user");
    const userData: AuthData = JSON.parse(storageUser || "{}");

    if (userData?.accessToken) {
      config.headers["Authorization"] = `Bearer ${userData.accessToken}`;
    }

    return config;
  } catch (error) {
    log.error("Error setting auth header:", undefined, error);
    return config;
  }
});

export default api;
